import { unauthenticatedApi } from "@/lib/api/client";

export interface SignupRequest {
  companyName: string;
  creativeSupportOther?: null | string;
  creativeSupportType: string;
  email: string;
  fullName: string;
  industry: string;
  industryOther?: null | string;
  utmCampaign?: null | string;
  utmMedium?: null | string;
  utmSource?: null | string;
}

export interface SignupResponse {
  applicationId: number;
  email: string;
  message: string;
}

export interface VerifyEmailRequest {
  applicationId: number;
  code: string;
}

export interface VerifyEmailResponse {
  alreadyVerified?: boolean;
  applicationId: number;
  email: string;
  message: string;
  success: boolean;
  verified?: boolean;
}

export interface ResendCodeRequest {
  email: string;
}

export interface ResendCodeResponse {
  message: string;
  success: boolean;
}

export interface CheckEmailResponse {
  applicationId?: number;
  emailVerified?: boolean;
  exists: boolean;
  isUser?: boolean;
  projectId?: number;
  status?: string;
  userId?: number;
}

export interface CheckResetEligibilityResponse {
  eligible: boolean;
  reason?: string;
  userId?: number;
}

export const kickstarterApi = {
  checkEmail: (email: string): Promise<CheckEmailResponse> =>
    unauthenticatedApi
      .url(`/kickstarter/check-email/${encodeURIComponent(email)}`)
      .get()
      .json<CheckEmailResponse>(),

  checkResetEligibility: (
    email: string,
  ): Promise<CheckResetEligibilityResponse> =>
    unauthenticatedApi
      .url(`/kickstarter/check-reset-eligibility/${encodeURIComponent(email)}`)
      .get()
      .json<CheckResetEligibilityResponse>(),

  resendCode: (data: ResendCodeRequest): Promise<ResendCodeResponse> =>
    unauthenticatedApi
      .url("/kickstarter/resend-code")
      .post(data)
      .json<ResendCodeResponse>(),

  signup: (data: SignupRequest): Promise<SignupResponse> =>
    unauthenticatedApi
      .url("/kickstarter/signup")
      .post(data)
      .json<SignupResponse>(),

  verifyEmail: (data: VerifyEmailRequest): Promise<VerifyEmailResponse> =>
    unauthenticatedApi
      .url("/kickstarter/verify-email")
      .post(data)
      .json<VerifyEmailResponse>(),
};
